import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import MultiStepForm from "./MultiStepForm";
import BasicInfoForm from "./BasicInfoForm";
import ServicesForm from "./ServicesForm";
import AddonsForm from "./AddonsForm";
import PhotosForm from "./PhotosForm";
import VideosForm from "./VideosForm";
import { Box, Card, CircularProgress } from "@mui/material";
import "../../Components/Common/Styles/Formstyles.css";
import { GetApiMethod, PatchApiMethod, PostApiMethod } from "../../Utils/ApiService";

export interface ProviderType {
  id?: string;
  providerName?: string;
  contactPerson?: string;
  email?: string;
  phone?: string | string[];
  categories?: string[];
  categoriesDetail?: string[];
  aboutCompany?: string;
  services?: any[];
  addons?: any[];
  photos?: any[];
  videos?: any[];
  imageUrl?: string; // include image URL
  //  providerHasPortfolio?: PortfolioType[];
}

const stepIndexMap: Record<string, number> = {
  basicInfo: 0,
  services: 1,
  addons: 2,
  photos: 3,
  videos: 4,
};

const stepLabelMap = ["Basic Info", "Services", "Addons", "Photos", "Videos"];

const ProviderForm: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const provider = location.state?.provider as ProviderType | undefined;
  const isEditMode = !!provider;

  const [activeStepIndex, setActiveStepIndex] = useState(stepIndexMap["basicInfo"]);
  const [loading, setLoading] = useState(false);

  interface FormDataType {
    providerId?: string;
    basicInfo: {
      providerName: string;
      contactPerson: string;
      email: string;
      phoneNumber: string;
      aboutCompany: string;
      categoriesOffered: string[];
      image?: string | File; // URL or new File
    };
    services: any[];
    addons: any[];
    photos: any[];
    videos: any[];
  }

  const [formData, setFormData] = useState<FormDataType>({
    providerId: "",
    basicInfo: {
      providerName: "",
      contactPerson: "",
      email: "",
      phoneNumber: "",
      aboutCompany: "",
      categoriesOffered: [],
      image: "",
    },
    services: [],
    addons: [],
    photos: [],
    videos: [],
  });

  const { providerId } = useParams<{ providerId: string }>();
  console.log("+++++++++", formData);

  const fetchProviderById = async () => {
    if (!providerId) return;
    try {
      const response = await GetApiMethod(`provider/${providerId}`);
      const fetchedProvider = response?.data?.data;

      console.log("==========", fetchedProvider);

      if (fetchedProvider) {
        setFormData({
          providerId: fetchedProvider.id,
          basicInfo: {
            providerName: fetchedProvider.providerName || "",
            contactPerson: fetchedProvider.contactPerson || "",
            email: fetchedProvider.email || "",
            phoneNumber: fetchedProvider.phone,
            aboutCompany: fetchedProvider.aboutCompany || "",
            categoriesOffered: fetchedProvider.categoriesDetail || [],
            image: fetchedProvider.imageUrl || "",
          },
          services: fetchedProvider.services || [],
          addons: fetchedProvider.addons || [],
          photos: fetchedProvider.photos || [],
          videos: fetchedProvider.videos || [],
        });
      }
    } catch (error) {
      console.error("Error fetching provider:", error);
    }
  };

  useEffect(() => {
    if (providerId) {
      fetchProviderById();
    }
  }, [providerId]);

  // Populate formData if editing
  useEffect(() => {
    if (provider) {
      const phoneValue = Array.isArray(provider.phone)
        ? provider.phone.join(", ")
        : provider.phone || "";

      setFormData({
        providerId: provider.id,
        basicInfo: {
          providerName: provider.providerName || "",
          contactPerson: provider.contactPerson || "",
          email: provider.email || "",
          phoneNumber: phoneValue,
          aboutCompany: provider.aboutCompany || "",
          categoriesOffered: provider.categoriesDetail || [],
          image: provider.imageUrl || "",
        },
        services: provider.services || [],
        addons: provider.addons || [],
        photos: provider.photos || [],
        videos: provider.videos || [],
      });
    }
  }, []);

  const handleNext = () => {
    if (activeStepIndex < stepLabelMap.length - 1) setActiveStepIndex(prev => prev + 1);
  };

  const handleBack = () => {
    if (activeStepIndex > 0) setActiveStepIndex(prev => prev - 1);
  };

  const submitProviderBasicInfo = async () => {
    const basicFormData = new FormData();

    basicFormData.append("providerName", formData.basicInfo.providerName);
    basicFormData.append("email", formData.basicInfo.email);
    basicFormData.append("contactPerson", formData.basicInfo.contactPerson);
    basicFormData.append("aboutCompany", formData.basicInfo.aboutCompany);
    basicFormData.append("phone", formData.basicInfo.phoneNumber);

    if (formData.basicInfo.categoriesOffered.length === 0) {
      alert("Please select at least one category");
      setLoading(false);
      return;
    }

    formData.basicInfo.categoriesOffered.forEach((cat: any) => {
      const catId = typeof cat === "string" ? cat : cat.id;
      basicFormData.append("categories[]", catId);
    });

    // Multiple files (photos) if any new files are selected
    if (Array.isArray(formData.basicInfo.image)) {
      formData.basicInfo.image
        .filter(f => f instanceof File)
        .forEach(f => basicFormData.append("files", f));
    } else if (formData.basicInfo.image instanceof File) {
      // fallback if single file
      basicFormData.append("files", formData.basicInfo.image);
    }

    // PATCH for edit, POST for create
    let basicRes;
    if (formData.providerId) {
      basicRes = await PatchApiMethod(
        `provider/${formData.providerId}`,
        basicFormData,
        // { headers: { "Content-Type": "multipart/form-data" } }
      );
    } else {
      basicRes = await PostApiMethod(
        "provider",
        basicFormData,
        // { headers: { "Content-Type": "multipart/form-data" } }
      );
      formData.providerId = basicRes.data.data.id;
    }
  }

  const submitProviderServices = async () => {
    console.log("serivicesData++++++++",formData.services,formData.services.length)
    if (!formData.services.length) return;
    console.log("servicessssssss", formData)
    for (const s of formData.services) {
      console.log("foemdataservices", formData.services)
      const payload = {
        providerId: formData.providerId,
        serviceId: s.service?.serviceId || s.service,
        cost: s.cost,
        type: "Services",
      };

      if (s.id) {
        // Update existing service
        console.log("Payload being sent:", payload);
        await PatchApiMethod(`provider-service/update/${s.id}`, payload);
        console.log("iddddddddddddd",s.id)
        console.log("costttttt", s.cost,)
      } else {
        // Create new service
        await PostApiMethod("provider-service/create", [payload]);
      }
    }
  };


  const submitProviderAddons = async () => {
    if (!formData.addons.length) return;
    console.log("formData+++++++++++",formData.addons)
    for (const a of formData.addons) {
      const payload = {
        providerId: formData.providerId,
        serviceId: a.serviceId,
        cost: a.cost,
        type: "Addons",
      };

      if (a.id) {
        await PatchApiMethod(`provider-service/update/${a.id}`, payload);
        console.log("addonspatch++++",payload)
      } else {
        await PostApiMethod("provider-service/create", [payload]);
      }
    }
  };
  const submitProviderPhotos = async () => {
    console.log("photosdata++++++++++++++",formData.photos)
    let isNewfileSelected = false;
    for (const photo of formData.photos) {
      const photoFormData = new FormData();
      // Only append if it's a new file
      if (photo instanceof File) {
       isNewfileSelected=true;
        photoFormData.append("files", photo);
      }
      if ("id" in photo && photo.id) {
        if(isNewfileSelected){
           //  Update existing photo by its portfolio ID
        await PatchApiMethod(`provider-portfolio/${photo.id}`, photoFormData, );
        }
      } else {
        //  New photo, create
        photoFormData.append("providerId", formData.providerId!);
        const res = await PostApiMethod("provider-portfolio/create", photoFormData, {

        });
        // Replace the new File in formData.photos with returned uploaded info
        const uploadedUrls = res.data.uploadedUrls || [];
        uploadedUrls.forEach((url: any, idx: number) => {
          const index = formData.photos.findIndex(p => p === photo);
          if (index !== -1) formData.photos[index] = url;
        });
      }
    }

  }
  const submitProviderVideos = async () => {
    let isNewfileSelected = false;
    for (const video of formData.videos) {
      const videoFormData = new FormData();

      // Only append if it's a new file
      if (video instanceof File) {
        isNewfileSelected=true;
        videoFormData.append("files", video);
      }

      if ("id" in video && video.id) {
        if(isNewfileSelected){
            // Update existing video by its portfolio ID
 await PatchApiMethod(`provider-portfolio/${video.id}`, videoFormData, 
        );
        }
      
       
      } else {
        //  New video, create
        videoFormData.append("providerId", formData.providerId!);
        const res = await PostApiMethod("provider-portfolio/create", videoFormData, {

        });

        // Replace the new File in formData.videos with returned uploaded info
        const uploadedUrls = res.data.uploadedUrls || [];
        uploadedUrls.forEach((url: any, idx: number) => {
          const index = formData.videos.findIndex(v => v === video);
          if (index !== -1) formData.videos[index] = url;
        });
      }
    }
  };


  //  Centralized save for all steps
  const handleStepSave = async () => {
    setLoading(true);
    try {

      await submitProviderBasicInfo()
      await submitProviderServices()
      await submitProviderAddons()
      await submitProviderPhotos()
      await submitProviderVideos()

      alert("Provider saved successfully!");
      navigate("/providers");


    } catch (err) {
      console.error(err);
      alert("Error saving step");
    } finally {
      setLoading(false);
    }
  };


  return (
    <Box sx={{ px: 2, py: 3, fontFamily: "Poppins, Semibold" }}>
      <Card className="card-layout">
        <MultiStepForm
          steps={stepLabelMap}
          activeStep={stepLabelMap[activeStepIndex]}
          setActiveStep={(step) => setActiveStepIndex(stepIndexMap[step.toLowerCase()])}
          isEditMode={isEditMode}
        >
          {activeStepIndex === 0 && (
            <BasicInfoForm
              formData={formData}
              setFormData={setFormData}
              handleNext={handleNext}
              handleCancel={() => navigate("/providers")}
              provider={provider}
            />
          )}
          {activeStepIndex === 1 && (
            <ServicesForm
              formData={formData}
              setFormData={setFormData}
              handleNext={handleNext}
              handleBack={handleBack}
            />
          )}
          {activeStepIndex === 2 && (
            <AddonsForm
              formData={formData}
              setFormData={setFormData}
              handleNext={handleNext}
              handleBack={handleBack}
            />
          )}
          {activeStepIndex === 3 && (
            <PhotosForm
              formData={formData}
              setFormData={setFormData}
              handleNext={handleNext}
              handleBack={handleBack}
              title="Provider Photos"
            />
          )}
          {activeStepIndex === 4 && (
            <VideosForm
              formData={formData}
              setFormData={setFormData}
              handleBack={handleBack}
              handleSave={handleStepSave} // final save trigger
            />
          )}
        </MultiStepForm>

        {loading && (
          <Box display="flex" justifyContent="center" mt={2}>
            <CircularProgress size={24} />
          </Box>
        )}
      </Card>
    </Box>
  );
};

export default ProviderForm;
